import React from 'react'
import { Eye, Pencil, Users } from 'lucide-react'

interface KidsLandingProps {
  isAdmin: boolean
  onNavigate: (page: string) => void
}

export function KidsLanding({ isAdmin, onNavigate }: KidsLandingProps) {
  return (
    <div className="space-y-6">
      <div className="flex items-center space-x-3">
        <div className="p-2 bg-blue-100 rounded-lg">
          <Users className="h-6 w-6 text-blue-600" />
        </div>
        <h1 className="text-2xl font-bold text-gray-900">Enfants</h1>
      </div>

      <div className={`grid grid-cols-1 ${isAdmin ? 'sm:grid-cols-2' : ''} gap-6 max-w-2xl`}>
        <button
          onClick={() => onNavigate('kids-view')}
          className="group bg-white rounded-xl shadow-sm border border-gray-200 p-8 text-left hover:shadow-md hover:border-blue-300 transition-all"
        >
          <div className="flex items-center space-x-4 mb-4">
            <div className="p-3 bg-blue-50 rounded-lg group-hover:bg-blue-100 transition-colors">
              <Eye className="h-7 w-7 text-blue-600" />
            </div>
            <h2 className="text-lg font-semibold text-gray-900">Consulter</h2>
          </div>
          <p className="text-sm text-gray-600 leading-relaxed">
            Chercher un enfant (son nom, celui du parent, un e-mail) ou voir ceux d'une semaine, avec ce qu'il faut savoir.
          </p>
        </button>

        {isAdmin && (
          <button
            onClick={() => onNavigate('kids-edit')}
            className="group bg-white rounded-xl shadow-sm border border-gray-200 p-8 text-left hover:shadow-md hover:border-amber-300 transition-all"
          >
            <div className="flex items-center space-x-4 mb-4">
              <div className="p-3 bg-amber-50 rounded-lg group-hover:bg-amber-100 transition-colors">
                <Pencil className="h-7 w-7 text-amber-600" />
              </div>
              <h2 className="text-lg font-semibold text-gray-900">Modifier</h2>
            </div>
            <p className="text-sm text-gray-600 leading-relaxed">
              Modifier la fiche d'un enfant, avec les questions posées aux parents : identité et école, santé, journée en stage, sorties, autorisations (RGPD).
            </p>
          </button>
        )}
      </div>
    </div>
  )
}
